import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";

const ITEMS = [
  {
    status: "In Progress",
    live: true,
    degree: "Doctor of Business Administration — Artificial Intelligence & Machine Learning",
    institution: "Walsh College",
    detail: "Applied AI/ML for marketing measurement, incrementality and revenue forecasting.",
  },
  {
    status: "2025 — 2027",
    live: true,
    degree: "Professional Certified Marketer (AMA-PCM)",
    institution: "American Marketing Association",
    detail: "Continuing professional certification in strategic marketing and management.",
  },
  {
    status: "2023 — 2025",
    live: false,
    degree: "Chartered Marketer — ACIM",
    institution: "The Chartered Institute of Marketing (CIM)",
    detail: "The profession's globally recognised standard.",
  },
  {
    status: "2022 — 2025",
    live: false,
    degree: "Post Graduate Program — Data Science & Business Analytics",
    institution: "The University of Texas at Austin · McCombs School",
    detail: "Statistical modelling, machine learning, applied analytics.",
  },
  {
    status: "2018 — 2020",
    live: false,
    degree: "MBA (PGDM) — Marketing",
    institution: "Institute of Management Technology, Ghaziabad",
    detail: "Master of Business Administration specialising in Marketing.",
  },
  {
    status: "2015 — 2018",
    live: false,
    degree: "Bachelor of Arts — Tourism Management",
    institution: "University of Delhi · College of Vocational Studies",
    detail: "Undergraduate degree in Tourism Management from CVS, University of Delhi.",
  },
];

export default function Education() {
  return (
    <section id="education" className="relative container-x py-24 md:py-40" data-testid="education-section">
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-20">
        <div className="col-span-12 md:col-span-4">
          <p className="eyebrow">Credentials</p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[0.96] tracking-tight text-ink"
            data-testid="education-title"
          >
            Studying the systems behind the systems.
          </motion.h2>
        </div>
      </div>

      <div className="space-y-6" data-testid="education-list">
        {ITEMS.map((it, i) => (
          <motion.div
            key={it.degree}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-12 gap-4 md:gap-8 items-start border border-stroke bg-matte p-6 md:p-10 hover:border-laser/50 transition-colors"
            data-testid={`education-item-${i}`}
          >
            <div className="col-span-12 md:col-span-3 flex items-center gap-3">
              {it.live ? (
                <span className="relative flex items-center justify-center w-2.5 h-2.5">
                  <span className="absolute inline-flex h-full w-full bg-laser/50 animate-pulse-dot" />
                  <span className="relative inline-flex w-2.5 h-2.5 bg-laser" />
                </span>
              ) : (
                <span className="w-2.5 h-2.5 border border-stroke" />
              )}
              <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-laser">
                {it.status}
              </span>
            </div>
            <div className="col-span-12 md:col-span-9">
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-serif font-light text-2xl md:text-3xl text-ink leading-tight tracking-tight">
                  {it.degree}
                </h3>
                <GraduationCap size={26} strokeWidth={1} className="text-steel shrink-0 mt-1" />
              </div>
              <div className="mt-2 font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-steel">
                {it.institution}
              </div>
              <p className="mt-4 font-sans text-base text-ink/70 max-w-2xl leading-relaxed">
                {it.detail}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
